import React, { Component, Fragment } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Form from 'react-bootstrap/Form';
import './FrequencyFormPopup.css';
import moment from 'moment';

export interface FrequencySelection {
  mainTab?: 'run' | 'frequency';
  runType?: 'time' | 'health';
  runAtValue?: string;
  frequency: 'daily' | 'weekly' | 'monthly';
  monthlyType?: 'specific' | 'weekday';
  monthlyText?: string;
  days_of_week?: string[];
  days_of_month?: string[];
  time_of_day?: string;
  week_of_month?: string;

}
interface IProps {
  handleClose?: () => void;
  onSave?: (data: FrequencySelection) => void;
  editData?: any;
}

interface IState {
  mainTab: 'run' | 'frequency';
  runType: 'time' | 'health';
  runAtValue: string;
  activeKey: 'daily' | 'weekly' | 'monthly';
  monthlySubKey: 'specific' | 'weekday';
  selectedDays: string[];
  selectedDates: string[];
  weekOrder: string;
  weekDay: string;
  message: string;

  invocationSchedulesError: string,
  invocationSchedulesHealthError: string,
}


export class FrequencyFormPopup extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      mainTab: 'run',
      runType: 'time',
      runAtValue: '',
      activeKey: 'daily',
      monthlySubKey: 'specific',
      selectedDays: [],
      selectedDates: [],
      weekOrder: 'first',
      weekDay: 'Sunday',
      message: '',
      invocationSchedulesError: "",
      invocationSchedulesHealthError: "",
    };
  }

  componentDidMount() {
    const { editData } = this.props;
    if (!editData) return;

    let detectedRunType: 'time' | 'health' = 'time';
    let detectedRunValue = '';

    if (editData.frequency_details?.time_of_day) {
      // time inside frequency
      detectedRunType = 'time';
      detectedRunValue = moment(editData.frequency_details?.time_of_day, "hh:mm A").format("HH:mm");
    }
    else if (editData.run_at_time) {
      // direct time
      detectedRunType = 'time';
      detectedRunValue = editData.run_at_time;
    }
    else if (editData.report_health) {
      // health schedule
      detectedRunType = 'health';
      detectedRunValue = String(editData.report_health);
    }

    this.setState({
      runType: detectedRunType,
      runAtValue: detectedRunValue
    });
    const {
      frequency,
      days_of_week = [],
      days_of_month = [],
      week_of_month = '',
      monthlyText = '',
    } = editData.frequency_details;
    // Daily
    if (frequency === 'daily') {
      this.setState({
        activeKey: 'daily',
        message: '',
      });
      return;
    }

    // Weekly
    if (frequency === 'weekly') {
      this.setState({
        activeKey: 'weekly',
        selectedDays: Array.isArray(days_of_week) ? days_of_week : [],
        message: monthlyText || '',
      });
      return;
    }

    // Monthly
    if (frequency === 'monthly') {
      if (week_of_month?.trim()) {
        const weekDayValue = days_of_week.length > 0
          ? days_of_week[0]
          : days_of_week || 'Sunday';

        this.setState({
          activeKey: 'monthly',
          monthlySubKey: 'weekday',
          weekOrder: week_of_month,
          weekDay: weekDayValue,
          message:
            monthlyText ||
            `Data will be pushed on the ${week_of_month} ${weekDayValue} of each month.`,
        });
      } else if (days_of_month.length > 0) {
        const selectedDates = days_of_month.map(String);
        this.setState({
          activeKey: 'monthly',
          monthlySubKey: 'specific',
          selectedDates,
          message:
            monthlyText ||
            `Data will be pushed on the ${selectedDates.join(', ')} of each month.`,
        });
      }
    }
  }





  handleClose = () => {
    this.props.handleClose?.();
  };

  handleSelect = (key: string | null) => {
    if (!key) return;
    this.setState({
      activeKey: key as 'daily' | 'weekly' | 'monthly',
      selectedDays: [],
      selectedDates: [],
      message: '',
    });
  };

  toggleDay = (day: string) => {
    this.setState((prev) => {
      const selectedDays = prev.selectedDays.includes(day)
        ? prev.selectedDays.filter((d) => d !== day)
        : [...prev.selectedDays, day];
      return {
        selectedDays,
        message: selectedDays.length
          ? `Data will be pushed on ${selectedDays.join(', ')} every week.`
          : '',
      };
    });
  };

  // Toggle multiple month dates
  toggleDate = (num: number) => {
    const numStr = num.toString();
    this.setState((prev) => {
      const selectedDates = prev.selectedDates.includes(numStr)
        ? prev.selectedDates.filter((d) => d !== numStr)
        : [...prev.selectedDates, numStr];
      return {
        selectedDates,
        message: selectedDates.length
          ? `Data will be pushed on days ${selectedDates.join(', ')} of each month.`
          : '',
      };
    });
  };

  handleMonthlySubSelect = (key: string | null) => {
    if (!key) return;
    this.setState({
      monthlySubKey: key as 'specific' | 'weekday',
      selectedDates: [],
      message: '',
    });
  };

  handleWeekChange = (field: 'order' | 'day', value: string) => {
    this.setState((prev) => {
      const newState = {
        ...prev,
        [field === 'order' ? 'weekOrder' : 'weekDay']: value,
      };
      return {
        ...newState,
        message: `Data will be pushed on the ${newState.weekOrder} ${newState.weekDay} of each month.`,
      };
    });
  };
  validateRunTab = (): boolean => {
    const { runType, runAtValue } = this.state;

    // Empty check (common)
    if (!runAtValue || !runAtValue.trim()) {
      if (runType === 'time') {
        this.setState({
          invocationSchedulesError: 'Time is required.',
          mainTab: 'run'
        });
      } else {
        this.setState({
          invocationSchedulesHealthError: 'Health value is required.',
          mainTab: 'run'
        });
      }
      return false;
    }

    // Specific validation
    if (runType === 'time') {
      return this.validateInvocationSchedule();
    }

    return this.validateInvocationScheduleHealth();
  };

  handleSave = () => {
    // save if Run/Health invalid
    const isRunValid = this.validateRunTab();
    if (!isRunValid) return;
    const {
      activeKey,
      selectedDays,
      selectedDates,
      monthlySubKey,
      weekOrder,
      weekDay,
      runType,
      runAtValue,
    } = this.state;

    let data: FrequencySelection;

    if (activeKey === 'daily') {
      data = {
        frequency: 'daily',
        days_of_week: [],
        days_of_month: [],
        week_of_month: '',
      };
    } else if (activeKey === 'weekly') {
      data = {
        frequency: 'weekly',
        days_of_week: [...selectedDays],
        days_of_month: [],
        week_of_month: '',
      };
    } else if (activeKey === 'monthly' && monthlySubKey === 'specific') {
      data = {
        frequency: 'monthly',
        days_of_month: [...selectedDates],
        days_of_week: [],
        week_of_month: '',
      };
    } else {
      // Monthly (Days of Week) mode
      data = {
        frequency: 'monthly',
        week_of_month: weekOrder,
        days_of_week: [weekDay],
        days_of_month: [],
      };
    }

    this.props.onSave?.({
      ...data,
      runType,
      runAtValue
    });
    this.handleClose();
  };
  setRunType = (type: 'time' | 'health') => {
    this.setState({ runType: type, runAtValue: '' });
  };
  validateInvocationScheduleHealth() {
    let { runAtValue } = this.state;
    let invocationSchedulesHealthError = "";

    if (runAtValue !== "") {
      const pattern = /^(100|[1-9][0-9]?)$/;
      const valid = pattern.test(runAtValue);

      if (!valid) {
        invocationSchedulesHealthError = "Please enter a valid health value (1–100).";
      }
    }

    this.setState({ invocationSchedulesHealthError });
    return invocationSchedulesHealthError === "";
  }
  validateInvocationSchedule() {
    let { runAtValue } = this.state;
    let invocationSchedulesError = "";

    if (runAtValue !== "") {
      const pattern = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
      const valid = pattern.test(runAtValue);

      // Standard validation
      if (!valid) {
        invocationSchedulesError = "Please enter correct time format (HH:mm).";
      }
    }

    this.setState({ invocationSchedulesError });
    return invocationSchedulesError === "";
  }


  handleRunInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    this.setState({ runAtValue: value }, () => {
      if (this.state.runType === "time") {
        this.validateInvocationSchedule();
      } else {
        this.validateInvocationScheduleHealth();
      }
    });
  };

  render() {
    const { activeKey, selectedDays, selectedDates, monthlySubKey, weekOrder, weekDay, message } = this.state;

    const daysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const monthDays = Array.from({ length: 31 }, (_, i) => i + 1);
    const weekOrders = ['first', 'second', 'third', 'fourth', 'last'];

    return (
      <Fragment>
        <Modal.Header closeButton>
          <Modal.Title>Schedule Configuration</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* ================= MAIN TWO TABS ================= */}
          <Tab.Container activeKey={this.state.mainTab} onSelect={(k) => this.setState({ mainTab: k as any })}>
            <Nav variant="tabs" className="mb-3">
              <Nav.Item>
                <Nav.Link eventKey="run">Set Run At Time / Health</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="frequency">Frequency Configuration</Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              {/* ================= TAB 1: RUN / HEALTH ================= */}
              <Tab.Pane eventKey="run">
                <div className="p-3 grey-bg rounded">

                  <div className="d-flex align-items-center">
                    <Form.Check
                      type="radio"
                      label="Time"
                      name="runType"
                      className="radio-fix mr-2"
                      checked={this.state.runType === 'time'}
                      onChange={() => this.setRunType('time')}
                      disabled={!!this.props.editData}
                    />

                    <Form.Check
                      type="radio"
                      label="Health"
                      name="runType"
                      className="radio-fix"
                      checked={this.state.runType === 'health'}
                      onChange={() => this.setRunType('health')}
                      disabled={!!this.props.editData}
                    />
                  </div>





                  {!!this.props.editData && <span className="text-muted small text-right pe-3">
                    Run at type cann't be changed for existing schedules.
                  </span>}
                  {/* Health Input */}
                  {this.state.runType === 'time' && (
                    <div className="mt-3">
                      <label className="mb-1">Time<span className=" text-danger">*</span></label>
                      <Form.Control
                        className="mt-1"
                        type="text"
                        placeholder="Ex.: 13:00"
                        value={this.state.runAtValue}
                        onChange={this.handleRunInput}
                      />
                      <div className="invalid-feedback">
                        {this.state.invocationSchedulesError}
                      </div>
                    </div>
                  )}

                  {/* Health Input */}
                  {this.state.runType === 'health' && (
                    <div className="mt-3">
                      <label className="mb-1">Health<span className=" text-danger">*</span></label>
                      <Form.Control
                        type="text"
                        placeholder="Ex.: 75"
                        value={this.state.runAtValue}
                        onChange={this.handleRunInput}
                      />

                      <div className="invalid-feedback">
                        {this.state.invocationSchedulesHealthError}
                      </div>
                    </div>
                  )}

                </div>
              </Tab.Pane>

              {/* ================= TAB 2: FREQUENCY CONFIGURATION ================= */}
              <Tab.Pane eventKey="frequency">
                {/* Your ENTIRE existing Daily/Weekly/Monthly code stays here */}

                <Tab.Container activeKey={activeKey} onSelect={this.handleSelect}>
                  <Nav variant="tabs" className="mb-3">
                    <Nav.Item><Nav.Link eventKey="daily">Daily</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link eventKey="weekly">Weekly</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link eventKey="monthly">Monthly</Nav.Link></Nav.Item>
                  </Nav>

                  <Tab.Content>
                    {/* === Daily === */}
                    <Tab.Pane eventKey="daily">
                      <p className="text-center py-3 grey-bg">Data will be pushed every day.</p>
                    </Tab.Pane>

                    {/* === Weekly === */}
                    <Tab.Pane eventKey="weekly">
                      <div className="d-flex justify-content-center flex-wrap py-3 grey-bg">
                        {daysFull.map((day) => (
                          <div
                            key={day}
                            onClick={() => this.toggleDay(day)}
                            className={`weekly-day ${selectedDays.includes(day) ? 'selected' : ''}`}
                          >
                            {day.charAt(0)}
                          </div>
                        ))}
                      </div>
                    </Tab.Pane>

                    {/* === Monthly === */}
                    <Tab.Pane eventKey="monthly">
                      <div className="grey-bg p-3 rounded">

                        {/* Sub-tabs */}
                        <div className="monthly-subtabs mb-3">
                          <button
                            type="button"
                            className={`monthly-subtab-btn ${monthlySubKey === 'specific' ? 'selected' : ''}`}
                            onClick={() => this.handleMonthlySubSelect('specific')}
                          >
                            Specific Dates
                          </button>

                          <button
                            type="button"
                            className={`monthly-subtab-btn ${monthlySubKey === 'weekday' ? 'selected' : ''}`}
                            onClick={() => this.handleMonthlySubSelect('weekday')}
                          >
                            Days of Week
                          </button>
                        </div>

                        {/* Monthly Content */}
                        <Tab.Content>
                          {monthlySubKey === 'specific' && (
                            <div className="d-flex flex-wrap justify-content-center py-3">
                              {monthDays.map((num) => (
                                <div
                                  key={num}
                                  onClick={() => this.toggleDate(num)}
                                  className={`monthly-date ${selectedDates.includes(num.toString()) ? 'selected' : ''}`}
                                >
                                  {num}
                                </div>
                              ))}
                            </div>
                          )}

                          <div className="text-muted small mt-1 text-right pe-3">
                            Schedules won’t run in months where the selected day doesn’t exist.
                          </div>

                          {monthlySubKey === 'weekday' && (
                            <div className="d-flex flex-column align-items-center py-3">
                              <Form.Group className="d-flex align-items-center mb-3">
                                <Form.Control
                                  as="select"
                                  value={weekOrder}
                                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => this.handleWeekChange('order', e.target.value)}
                                >
                                  {weekOrders.map((order) => (
                                    <option key={order} value={order}>
                                      {order}
                                    </option>
                                  ))}
                                </Form.Control>

                                <Form.Control
                                  as="select"
                                  value={weekDay}
                                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => this.handleWeekChange('day', e.target.value)}
                                >
                                  {daysFull.map((day) => (
                                    <option key={day} value={day}>{day}</option>
                                  ))}
                                </Form.Control>
                              </Form.Group>
                            </div>
                          )}
                        </Tab.Content>

                      </div>
                    </Tab.Pane>
                    {message && <p className="text-center py-3">{message}</p>}
                  </Tab.Content>

                </Tab.Container>

              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Modal.Body>
        <Modal.Footer>
          <div className="modal-action-line"></div>
          <Button variant="secondary" onClick={this.handleClose}>Cancel</Button>
          <Button variant="primary" type="button" onClick={this.handleSave}>Save</Button>
        </Modal.Footer>
      </Fragment>
    );
  }
}

export default FrequencyFormPopup;
